var screenWidthsMixin = {

	computed: {

		windowWidth() {
			return window.innerWidth;
		},
		
		isMobile() {
			if (window.innerWidth < 520) return true;
			return false;
		},

		isTablet() {
			if (window.innerWidth < 769) return true;
			return false;
		},

		isDesktop() {
			if (window.innerWidth >= 769) return true;
			return false;
		},

	},
	

};

export { screenWidthsMixin };
